module.exports = __webpack_public_path__ + "static/media/formatoMaestriaEducacion.4d648615.docx";